function ProjectCardButtonContainer(props) {
  let buttons = [];
  if (props.buttonMap != null) {
    props.buttonMap.forEach((element) => {
      buttons.push(
        <a href={element.targetUrl}>
          {element.title}
        </a>
      );
    });
  }

  return <div className="Project-content-buttons">{buttons}</div>;
}

function ProjectCardImageContainer(props) {
  let images = [];
  if (props.imageRefs != null) {
    props.imageRefs.forEach((imageRef) => {
      images.push(<img src={imageRef} alt="project media" />);
    });
  }

  return <div className={props.name}>{images}</div>;
}

export {ProjectCardButtonContainer, ProjectCardImageContainer}